import { render, staticRenderFns } from "./PerkButton.vue?vue&type=template&id=11be3d61&scoped=true&"
import script from "./PerkButton.vue?vue&type=script&lang=js&"
export * from "./PerkButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11be3d61",
  null
  
)

export default component.exports